import React, { useEffect } from "react";
import "./terms.scss";
function Terms() {
  useEffect(() => {
    document.title = "educare - T & C";

    return () => {
      document.title = "educare ";
    };
  });
  return (
    <>
      <div className="terms-bg">
        <center>
          <h1>Terms of Service (ToS)</h1>
          <p>Last Updated: 12/01/2025</p>
        </center>
      </div>
      <div className="terms-inner offset-md-2 col-md-8">
        <h1>Introduction</h1>
        <p>
          Thank you for choosing{" "}
          <strong>Educare Technology Solutions Limited</strong> (“Educare,”
          “we,” “our,” or “us”). These Terms of Service (“Terms”) govern your
          use of our website and SaaS products, including{" "}
          <strong>“Educare for School</strong>” and{" "}
          <strong>“Educare for Business.</strong>” By registering, creating an
          account, or using our Services, you agree to these Terms.
        </p>
        <h1>1. Services</h1>
        <p>
          Educare provides a comprehensive{" "}
          <strong>management ERP platform </strong> for schools and businesses,
          including:
        </p>
        <ul>
          <li>Student or business information management</li>
          <li>Attendance and timetable/scheduling</li>
          <li>Fees and finance management</li>
          <li>Academic tracking or business operations</li>
          <li>HR and staff management</li>
          <li>Communication and engagement tools</li>
          <li>Analytics and reporting</li>
        </ul>
        <p>
          We may update, modify, or discontinue Services at any time without
          prior notice.
        </p>

        <h1>2. User Accounts S</h1>

        <ul>
          <li>
            Users must provide accurate, current, and complete information when
            creating an account.
          </li>
          <li>
            Users are responsible for account credentials and all activity under
            their accounts.
          </li>
          <li>
            Users are responsible for account credentials and all activity under
            their accounts.
          </li>
        </ul>

        <h1>3. Acceptable Use</h1>
        <p>Users must not:</p>
        <ul>
          <li>Use Services for illegal or unauthorized purposes.</li>
          <li>Attempt unauthorized access to our systems.</li>
          <li>Impersonate others or provide false information.</li>
          <li>Use automated scripts or tools to extract data.</li>
          <li>Upload malware, viruses, or harmful code.</li>
          <li>Harass or abuse other users.</li>
        </ul>

        <h1>4. Intellectual Property</h1>
        <p>
          All content, software, and materials provided by Educare are owned or
          licensed by Educare. Users may not copy, modify, distribute, or
          exploit these materials outside of permitted use in the Services.
        </p>

        <h1>5. Payments and Subscriptions</h1>

        <ul>
          <li>
            Fees must be paid in accordance with the chosen subscription plan.
          </li>
          <li>
            Non-payment may result in suspension or termination of access.
          </li>
          <li>Fees are non-refundable unless explicitly stated.</li>
        </ul>

        <h1>6. Termination</h1>
        <p>
          Educare may suspend or terminate user accounts for violations of these
          Terms or misuse of Services. Users may terminate accounts at any time.
          Upon termination, data may be deleted or anonymized according to the
          Privacy Policy.
        </p>

        <h1>7. Disclaimers and Limitation of Liability</h1>
        <ul>
          <li>Services are provided “as-is” without warranties.</li>
          <li>
            Educare is not liable for indirect, incidental, or consequential
            damages.
          </li>
          <li>
            Total liability will not exceed fees paid by the user, where
            applicable.
          </li>
        </ul>

        <h1>8. Indemnification</h1>
        <p>
          Users agree to indemnify and hold Educare harmless against claims,
          damages, or losses arising from their use of the Services, violation
          of Terms, or legal breaches.
        </p>
        <h1>9. Governing Law</h1>
        <p>
          These Terms are governed by the laws of Nigeria. Disputes will be
          subject to the exclusive jurisdiction of Nigerian courts.
        </p>
        <h1>10. Changes to Terms</h1>
        <p>
          Educare may update these Terms at any time. The updated “Last Updated”
          date indicates the most recent version. Continued use constitutes
          acceptance.
        </p>
        <h1>11. Contact Information</h1>
        <p>
          Educare Technology Solutions Limited
          <br />
          16B, Alhaji Hussein Sunmonu Street, Lekki Phase 1, Lagos State,
          Nigeria
          <br />
          <strong>Email:</strong> support@educare.ng
        </p>
      </div>
    </>
  );
}

export default Terms;
